import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 24, height = 24, color = 'currentColor' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 24 24'>
  <path d='M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z' fill={color} />
</svg>
